import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSkeletonLoader',
  props: {
    type: {},
    styles: {}
  },
  setup(__props: any) {

const props = __props;
const cssProps = computed(() => {
  return {
    '--width': props.styles?.width,
    '--height': props.styles?.height,
    '--border-radius': props.styles?.borderRadius,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.type, "skeleton-loading"]),
    style: _normalizeStyle([cssProps.value])
  }, null, 6))
}
}

})